import {ProgressRingContainer} from './my-goals-v2.styles';

export const ProgressRing = ({progress}: {progress: number}) => {
  const normalizedProgress = Math.min(100, Math.max(0, progress));

  return (
    <ProgressRingContainer
      role="img"
      aria-label={`Average progress ${normalizedProgress} percent`}>
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="29" pathLength="100" />
        <circle
          cx="32"
          cy="32"
          r="29"
          pathLength="100"
          style={{strokeDashoffset: 100 - normalizedProgress}}
        />
      </svg>
      <span>{normalizedProgress}%</span>
    </ProgressRingContainer>
  );
};
